var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollowers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 45V39.6667C36 36.8377 35.1045 34.1246 33.5104 32.1242C31.9163 30.1238 29.7543 29 27.5 29H10.5C8.24566 29 6.08365 30.1238 4.48959 32.1242C2.89553 34.1246 2 36.8377 2 39.6667V45",
    stroke: "#2667FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 21C23.9706 21 28 16.9706 28 12C28 7.02944 23.9706 3 19 3C14.0294 3 10 7.02944 10 12C10 16.9706 14.0294 21 19 21Z",
    stroke: "#2667FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47 44.9995V39.6662C46.9982 37.3028 46.2116 35.0069 44.7636 33.139C43.3157 31.2711 41.2883 29.937 39 29.3462",
    stroke: "#2667FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 3C34.0024 3.51167 35.7772 4.67389 37.0446 6.30343C38.3121 7.93297 39 9.93715 39 12C39 14.0628 38.3121 16.067 37.0446 17.6966C35.7772 19.3261 34.0024 20.4883 32 21",
    stroke: "#2667FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowers);
export default __webpack_public_path__ + "static/media/Followers.ec9de0315be279bf865aa419845f3cf0.svg";
export { ForwardRef as ReactComponent };